import React, { useEffect, useState } from "react";
import { Breadcrumb, Container, Modal } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import useSEO from "../hooks/useSEO";
import { MyApi } from "../MyApi";

export default function CmsPage() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
 const [gallery, setGallery] = useState([]);
const [showModal, setShowModal] = useState(false);
const [activeIndex, setActiveIndex] = useState(0);

// gallery
const openModal = (index) => {
  setActiveIndex(index);
  setShowModal(true);
};

const handleClose = () => setShowModal(false);

// const nextImage = () => {
//   setActiveIndex((prev) => (prev + 1) % gallery.length);
// };

// const prevImage = () => {
//   setActiveIndex((prev) =>
//     prev === 0 ? gallery.length - 1 : prev - 1
//   );
// };

// end
  // Fetch CMS page data from API
  useEffect(() => {
    const fetchPage = async () => {
      try {
        setLoading(true);
        setError(false);

        const res = await axios.get(MyApi.BASE_URL + MyApi.CMS_PAGE + slug, {
          headers: { Authorization: MyApi.SECRET_KEY },
        });

        if (res.data.status && res.data.data) {
  setData(res.data.data);
  setGallery(res.data.gallery || []);
} else {
          setError(true);
        }
      } catch (err) {
        console.error("CMS API Error:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchPage();
  }, [slug]);

  // Set SEO dynamically
  useSEO({
    title: data?.meta_title || data?.pagename || "Kashi Journeys | Best Day Tours & Travel Guide in Varanasi",
    description: data?.meta_description || "Explore the real Varanasi with Kashi Journeys. Experience authentic day tours, sacred Ganga Ghats, ancient temples, hidden alleys, local markets & spiritual heritage with expert local guides.",
    keywords: data?.meta_tags || "Kashi Journeys, Varanasi day tours, Varanasi tour packages, Ganga ghat tour, Varanasi local guide, temple tour Varanasi, Varanasi sightseeing, spiritual tours India, Banaras travel, Varanasi heritage walk, Varanasi travel agency",
    canonical: window.location.href,
    ogImage: data?.top_header_bg_image || "",
  });

  if (loading) return <p className="text-center py-5">Loading...</p>;
  if (error) return <Container className="py-5 text-center"><h1>404 - Page Not Found</h1></Container>;

  return (
    <div>
    <div className="BreadcrumbStyle">
       <Container>
          <h1>{data.pagename || data.pageheading}</h1>
          <Breadcrumb>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
            <Breadcrumb.Item active>{data.pagename || data.pageheading}</Breadcrumb.Item>
          </Breadcrumb>
        </Container>
    </div>
    <div className="pageStyle">
      <Container>
        
        <div dangerouslySetInnerHTML={{ __html: data.pagecontent }} />
        <div>
          {gallery.length > 0 && (
            <div className="mt-5">
              {/* <h3 className="mb-4">
                {data.pagename || data.pageheading} 
              </h3> */}

              <div className="row g-3">
                {gallery.map((img, index) => (
                  <div className="col-6 col-md-4 col-lg-3" key={index}>
                    <div
                      className="gallery-item rounded-4 overflow-hidden"
                      role="button"
                      onClick={() => openModal(index)}   // ✅ REQUIRED
                    >
                      <img
                        src={img.image_url}
                        alt={`${img.gallerytitle} ${index + 1}`}
                        className="img-fluid w-100"
                      />
                      
                    </div>
                    <p className="text-center mt-1">{img.gallerytitle}</p>
                  </div>
                ))}
              </div>
            </div>
          )}


                  </div>
                </Container>
                </div>
              <Modal
  show={showModal}
  onHide={handleClose}
  centered
  fullscreen="md-down"       // 🔹 Fullscreen on mobile/tablet
  contentClassName="gallery-modal-content"
  backdropClassName="gallery-backdrop"
>
  <Modal.Body className="p-0 text-center position-relative">

    {/* ❌ Custom Close Button */}
    <button
      className="gallery-close-btn"
      onClick={handleClose}
      aria-label="Close"
    >
      ×
    </button>

    {/* ◀ Previous */}
    {/* <button
      className="gallery-nav gallery-prev"
      onClick={prevImage}
    >
      ‹
    </button> */}

    {/* IMAGE */}
    <img
      src={gallery[activeIndex]?.image_url}
      alt="Preview"
      className="img-fluid shadow"
      style={{
        maxHeight: "90vh",
        maxWidth: "95vw",
        objectFit: "contain", 
      }}
    />

    {/* ▶ Next */}
    {/* <button
      className="gallery-nav gallery-next"
      onClick={nextImage}
    >
      ›
    </button> */}

  </Modal.Body>
</Modal>

    </div>




  );
}
